module.exports = __webpack_public_path__ + "static/media/pvf_logo.8500f679.jpg";